import React, { useEffect, useState } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import {
  ClassicEditor,
  Essentials,
  Paragraph,
  Bold,
  Italic,
  Heading,
  Link,
  List,
  BlockQuote,
  Table,
  MediaEmbed,
  PasteFromOffice,
  Font,
  Alignment,
} from "ckeditor5";

import "./announcement.css";
import { useNavigate, useNavigation } from "react-router-dom";
import SelectButton from "../../../components/SelectButton";
import download from "../../../assets/clarity_download-line.png";
import { createColumnHelper } from "@tanstack/react-table";
import moment from "moment";
import ReactTable from "../../../components/ReactTable";
import { BsPlusSquare } from "react-icons/bs";
import editBond from "../../../assets/editBond.png";
import delBond from "../../../assets/deleteBond.png";
import CustomPagination from "../../../components/CustomPagination";
import leftIcon from "../../../assets/Left Icons.png";
import axios from "axios";
import ReusableModal from "./ResuableModel";
import ToggleButton from "./Toggle";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import DeleteConfirmationModal from "../../../components/DeleteConfirmationModal";

export const base_url = process.env.REACT_APP_BASE_URL;
export const api_type = process.env.REACT_APP_API_TYPE;

const toastIds = {
  statusSuccess: 'announcement-status-success-toast',
  statusError: 'announcement-status-error-toast',
  addSuccess: 'announcement-add-success-toast',
  addError: 'announcement-add-error-toast',
  deleteSuccess: 'announcement-delete-success-toast',
  deleteError: 'announcement-delete-error-toast',
  validationError: 'announcement-validation-error-toast'
};

function UserManagementMain() {
  const navigate = useNavigate();
  const [announcementsData, setAnnouncementsData] = useState([]);
  // const [page, setPage] = useState(1);
  const [page, setPage] = useState(() => {
    const savedPage = localStorage.getItem('announcementPage');
    return savedPage ? Number(savedPage) : 1;
  });
  const [total, setTotal] = useState(0);
  const [pageSize, setPazeSize] = useState(0);

  const { userPermissionData } = useSelector((state) => state.userPermission);
  const { cmsBondListData } = useSelector((state) => state.cmsData);
  const [editBlog, setEditBlog] = useState({
    title: "",
    body: "",
    bondId: "",
  });
  const [error, setError] = useState(null);
  const [title, setTitle] = useState("");
  const [body, setText] = useState("");
  const [bondId, setBondId] = useState("");

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenEdit, setIsModalOpenEdit] = useState(false);

  // Add new state for tracking submission and delete confirmation
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [deleteConfirmation, setDeleteConfirmation] = useState({
    isOpen: false,
    id: null
  });

  const updateRole = (newValues) => {
    setEditBlog((prevState) => ({
      ...prevState,
      ...newValues,
      bondId: newValues.bondId,
    }));
    setTitle(newValues.title);
    setText(newValues.body);
    console.log("title", newValues?.body);
    setBondId(newValues.bondId);
    // setAuthor(newValues.author);
    // setDesignation(newValues.designation);
    setIsModalOpenEdit(true);
  };

  const columnHelper = createColumnHelper();

  const handleCancel = () => {
    // Reset form fields
    setTitle("");
    setText("");
    setBondId("");
    // setDesignation("");
    // setAuthor("");
  };

  const fetchAnnouncementdata = async () => {
    const endpoint = `${base_url}/${api_type}/cms/announcements?page=${page}`;

    try {
      const response = await axios.get(endpoint, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      console.log("role response 108", response);
      const sortedData = response?.data?.data?.announcements?.sort(
        (a, b) => a.id - b.id
      );

      setAnnouncementsData(sortedData);
      console.log(sortedData);
      console.log("total page", response?.data?.data?.totalPages);
      setPage(response?.data?.data?.currentPage);
      console.log(page);
      setTotal(response?.data?.data?.totalRecords);
      // setPazeSize(response?.data?.data?.totalPages); // Adjust according to your API response structure
    } catch (err) {
      console.error("Failed to fetch pending orders:", err);
      setError(err.message);
    }
  };
  useEffect(() => {
    fetchAnnouncementdata();
  }, [page]);

  const openModal = () => {
    // Reset form fields before opening add modal
    setTitle("");
    setText("");
    setBondId("");
    setIsModalOpen(true);
  };
  // const closeModal = () => setIsModalOpen(false) ; // Function to close modal
  const closeModalEdit = () => {
    setIsModalOpenEdit(false);
    // Reset edit form data when closing edit modal
    setEditBlog({
      title: "",
      body: "",
      bondId: "",
    });
  };

  const closeModal = () => {
    setIsModalOpen(false);
    // Reset all form fields when closing add modal
    setTitle("");
    setText("");
    setBondId("");
  };
  const toggleStatus = async (id) => {
    console.log("did", id);

    const endpoint = `${base_url}/${api_type}/cms/announcements/${id}/toggle`;

    try {
      const response = await axios.put(
        endpoint,
        {},
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`, // Replace 'your-auth-token' with the actual token
          },
        }
      );
      if (!toast.isActive(toastIds.statusSuccess)) {
        toast.success("Status Updated", {
          toastId: toastIds.statusSuccess,
          autoClose: 3000
        });
      }
      fetchAnnouncementdata();
    } catch (err) {
      if (!toast.isActive(toastIds.statusError)) {
        toast.error(err?.response?.data?.message || "Failed to update status", {
          toastId: toastIds.statusError,
          autoClose: 3000
        });
      }
      setError(err.message);
    }
  };

  const addNewBlog = async (type) => {
    // Prevent multiple submissions
    if (isSubmitting) return;

    // Validation for edit mode
    if (type === "edit") {
      if (!editBlog?.title?.trim() || !editBlog?.body?.trim()) {
        if (!toast.isActive(toastIds.validationError)) {
          toast.error("Please fill title and body before updating.", {
            toastId: toastIds.validationError,
            autoClose: 3000
          });
        }
        return;
      }
    } else {
      // Validation for new announcement
      if (!title?.trim() || !body?.trim()) {
        if (!toast.isActive(toastIds.validationError)) {
          toast.error("Please fill title and body before adding.", {
            toastId: toastIds.validationError,
            autoClose: 3000
          });
        }
        return;
      }
    }

    try {
      setIsSubmitting(true);
      const endpoint = `${base_url}/${api_type}/cms/announcements`;
      const endpointEdit = `${base_url}/${api_type}/cms/announcements/${editBlog?.id}`;
      const headers = {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      };

      const payload = type === "edit"
        ? {
            title: editBlog.title,
            body: editBlog.body,
            bondId: editBlog?.bondId ? parseInt(editBlog?.bondId) : null,
          }
        : {
            title,
            body,
            bondId: bondId ? parseInt(bondId) : null,
          };

      const response = type === "edit"
        ? await axios.put(endpointEdit, payload, { headers })
        : await axios.post(endpoint, payload, { headers });

      // Reset input fields
      setTitle("");
      setText("");
      setBondId("");

      if (!toast.isActive(toastIds.addSuccess)) {
        toast.success(
          type === "edit"
            ? "Announcement Updated Successfully"
            : "New Announcement Added",
          {
            toastId: toastIds.addSuccess,
            autoClose: 3000
          }
        );
      }
      fetchAnnouncementdata();
      setIsModalOpen(false);
      setIsModalOpenEdit(false);
    } catch (err) {
      if (!toast.isActive(toastIds.addError)) {
        toast.error(err?.response?.data?.message || "Failed to add announcement", {
          toastId: toastIds.addError,
          autoClose: 3000
        });
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const deleteAnnouncement = async (id) => {
    const endpoint = `${base_url}/${api_type}/cms/announcements/${id}`;

    try {
      const response = await axios.delete(endpoint, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      if (!toast.isActive(toastIds.deleteSuccess)) {
        toast.success("Announcement deleted successfully", {
          toastId: toastIds.deleteSuccess,
          autoClose: 3000
        });
      }
      fetchAnnouncementdata(); // Refresh the list after deletion
    } catch (err) {
      if (!toast.isActive(toastIds.deleteError)) {
        toast.error(err?.response?.data?.message || "Failed to delete announcement", {
          toastId: toastIds.deleteError,
          autoClose: 3000
        });
      }
    }
  };

  const stripHtml = (html) => {
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.body.textContent || "";
  };
  function renderValue(text) {
    const words = text?.split(" ");
    if (words?.length > 30) {
      return words?.slice(0, 30).join(" ") + " ....";
    }
    return text;
  }

  const stripHtmlforEdit = (html) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  };

  const columns = [
    columnHelper.display({
      id: "sn", // A unique ID for the column
      cell: (info) => {
        const status = info?.row?.original?.status;
        return (
          <div
            className={` w-[27px] h-[27 px] py-1 flex justify-center items-center rounded text-center text-sm 
               
            `}
          >
            {info.row.index + 1}
          </div>
        );
      },
      header: () => <span>Sr. No.</span>,
    }),
    columnHelper.accessor("title", {
      cell: (info) => info.renderValue(),
      header: () => <span>Heading</span>,
    }),
    columnHelper.accessor("body", {
      cell: (info) => (
        <>
          <style>
            {`
              ul, ol {
                margin: 0;
                padding-left: 20px;
                list-style: disc; /* Ensure bullet points */
              }
              ol {
                list-style: decimal; /* Ensure ordered list numbers */
              }
              li {
                margin-bottom: 5px;
              }
            `}
          </style>
          <div
            dangerouslySetInnerHTML={{
              __html: renderValue(info.renderValue()),
            }}
          />
        </>
      ),
      header: () => <span>Body</span>,
    }),
    columnHelper.accessor("bondId", {
      cell: (info) => info.renderValue(),
      header: () => <span>Bond</span>,
    }),
    // columnHelper.accessor("author", {
    //   cell: (info) => info.renderValue(),
    //   header: () => <span>Trigger</span>,
    // }),
    // columnHelper.accessor("designation", {
    //   cell: (info) => info.renderValue(),
    //   header: () => <span>Designation</span>,
    // }),
    // columnHelper.accessor("status", {
    //   cell: (info) => {
    //     const status = info?.row;
    //     const roleId = info?.row?.original?.id;
    //     const roleType = info?.row?.original?.name;

    //     console.log("info", info?.row?.original);
    //     return (
    //       <div
    //         className={` w-[50px] h-[27px] py-1 flex justify-center items-center rounded text-center text-sm`}
    //       >
    //         {/* {kycStatus === "approve" ? "Approved" : "Pending"} */}
    //         <ToggleButton
    //           value={status}
    //           handleToggleStatus={toggleStatus}
    //           roleId={roleId}
    //           roleType={roleType}
    //         />
    //       </div>
    //     );
    //   },
    //   header: () => <span>Status</span>,
    // }),

    columnHelper.accessor((row) => row, {
      id: "action",
      cell: (info) => {
        const uniqueId = info?.row?.original?.id;
        return (
          <div className="flex gap-2">
            {userPermissionData?.user?.edit && (
              <img
                src={editBond}
                alt="Edit"
                className="cursor-pointer"
                onClick={() => {
                  updateRole({
                    id: uniqueId,
                    title: info.row.original.title,
                    body: info.row.original.body,
                    bondId: info.row.original.bondId,
                  });
                }}
              />
            )}
            {userPermissionData?.bond?.delete && (
              <img
                src={delBond}
                alt="Delete"
                className="cursor-pointer"
                onClick={(e) => {
                  e.stopPropagation();
                  setDeleteConfirmation({
                    isOpen: true,
                    id: uniqueId
                  });
                }}
              />
            )}
          </div>
        );
      },
      header: () => <span>Action</span>,
    }),
  ];
  console.log("userPermissionData..", userPermissionData);

 

  // Update the delete function
  const handleDelete = async () => {
    if (!deleteConfirmation.id) return;
    
    try {
      const response = await axios.delete(
        `${base_url}/${api_type}/cms/announcements/${deleteConfirmation.id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (!toast.isActive(toastIds.deleteSuccess)) {
        toast.success("Announcement deleted successfully", {
          toastId: toastIds.deleteSuccess,
          autoClose: 3000
        });
      }
      fetchAnnouncementdata();
    } catch (err) {
      if (!toast.isActive(toastIds.deleteError)) {
        toast.error(err?.response?.data?.message || "Failed to delete announcement", {
          toastId: toastIds.deleteError,
          autoClose: 3000
        });
      }
    } finally {
      setDeleteConfirmation({ isOpen: false, id: null });
    }
  };

  return (
    <div className=" mt-[60px] px-4 ">
      <div className="bg-white px-8  mt-4 rounded-[10px] border">
        <div class="">
          <div class="flex flex-wrap justify-between  items-center gap-x-2 py-4 gap-y-4 ">
            <div className="flex gap-2">
              <div class="flex gap-0.5">
                <h1 className="text-[#252C32] text-[20px] font-bold">
                  Announcement{" "}
                </h1>
              </div>
            </div>
            {userPermissionData?.cms?.manage && (
              <div class="flex items-center bg-[#035C98]  rounded-[8px]">
                <button
                  class="btn flex items-center gap-2 text-white font-bold"
                  onClick={openModal}
                >
                  <BsPlusSquare size={18} className="mt-px" />
                  Add New
                </button>
              </div>
            )}
            {/* Modal Component */}
            {isModalOpen && (
              <ReusableModal
                content={
                  <div className="w-full max-w-md mx-auto my-auto bg-white ">
                    <h2 className="text-center text-[24px] font-semibold mb-4">
                      Add Announcement
                    </h2>

                    <label className="font-raleway text-[16px] font-medium leading-[18.78px] text-left text[#000000] ">
                      Heading
                    </label>
                    <div className="flex mt-2 mb-4">
                      <input
                        type="text"
                        value={title}
                        placeholder="type here"
                        className="w-full h-14 p-2.5 border border-[#E6E6E6] rounded-[13px] "
                        onChange={(e) => setTitle(e.target.value)}
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium mb-1">
                        Body Text
                      </label>
                      <div
                        style={{
                          // border: "1px solid #ccc",
                          padding: "10px",
                          marginTop: "10px",
                          lineHeight: "1.6",
                        }}
                      >
                        <style>
                          {`
                                              ul, ol {
                                                margin: 0;
                                                padding-left: 20px;
                                                list-style: disc; /* Ensure bullet points */
                                              }
                                              ol {
                                                list-style: decimal; /* Ensure ordered list numbers */
                                              }
                                              li {
                                                margin-bottom: 5px;
                                              }
                                            `}
                        </style>
                        <CKEditor
                          editor={ClassicEditor}
                          value={body}
                          onChange={(event, editor) => {
                            const data = editor.getData();
                            const plainText = stripHtml(data);
                            console.log("Extracted Text:", plainText); // Debugging log
                            setText(plainText); // Set only the plain text value
                          }}
                          config={{
                            licenseKey: "GPL", // Use the GPL license.
                            plugins: [
                              Essentials,
                              Paragraph,
                              Bold,
                              Italic,
                              Heading,
                              Link,
                              List,
                              BlockQuote,
                              Image,
                              // Table,
                              MediaEmbed,
                              PasteFromOffice,
                              Font,
                              Alignment,
                            ],
                            toolbar: [
                              "heading",
                              "|",
                              "bold",
                              "italic",
                              "link",
                              "|",
                              "bulletedList",
                              "numberedList",
                              "|",
                              "blockQuote",
                              "insertTable",
                              "|",
                              "undo",
                              "redo",
                              "|",
                              "alignment:left",
                              "alignment:center",
                              "alignment:right",
                              "alignment:justify",
                              "|",
                              "fontColor",
                              "fontBackgroundColor",
                              "fontSize",
                              "|",
                              // "mediaEmbed",
                            ],
                            
                          }}
                        />
                      </div>
                    </div>

                    <label className="font-raleway text-[16px] font-medium leading-[18.78px] text-left text-[#000000]">
                      Select Bond
                    </label>
                    <div className="flex mt-2 mb-4">
                      {/* <input
                        type="number"
                        value={bondId}
                        placeholder="Enter bond ID"
                        className="w-full h-14 p-2.5 border border-[#E6E6E6] rounded-[13px]"
                        onChange={(e) => setBondId(e.target.value)}
                      /> */}
                      <select
                        className="w-full h-14 p-2.5 border border-[#E6E6E6] rounded-[13px] "
                        name="section"
                        value={bondId}
                        onChange={(e) => setBondId(e.target.value)}
                      >
                        <option value="">Select section</option>
                        {cmsBondListData &&
                          cmsBondListData?.map((section) => (
                            <option key={section.value} value={section.id}>
                              {section.name}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>
                }
                onUpload={() => addNewBlog("new")}
                ButtonValue="Add"
                onClose={closeModal}
                isDisabled={isSubmitting}
              />
            )}
            {isModalOpenEdit && (
              <ReusableModal
                content={
                  <div className="w-full max-w-md mx-auto my-auto bg-white ">
                    <h2 className="text-center text-[24px] font-semibold mb-4">
                      Edit Announcement
                    </h2>

                    <label className="font-raleway text-[16px] font-medium leading-[18.78px] text-left text[#000000] ">
                      Heading
                    </label>
                    <div className="flex mt-2 mb-4">
                      <input
                        type="text"
                        value={editBlog?.title || ""}
                        placeholder="Type heading here"
                        className="w-full h-14 p-2.5 border border-[#E6E6E6] rounded-[13px]"
                        onChange={(e) =>
                          setEditBlog((prevState) => ({
                            ...prevState,
                            title: e.target.value, // Update title in the editBlog state
                          }))
                        }
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium mb-1">
                        Body Text
                      </label>
                      <div
                        style={{
                          padding: "10px",
                          marginTop: "10px",
                          lineHeight: "1.6",
                        }}
                      >
                        <style>
                          {`
        ul, ol {
          margin: 0;
          padding-left: 20px;
          list-style: disc; /* Ensure bullet points */
        }
        ol {
          list-style: decimal; /* Ensure ordered list numbers */
        }
        li {
          margin-bottom: 5px;
        }
      `}
                        </style>
                        <CKEditor
                          editor={ClassicEditor}
                          data={editBlog?.body || ""} // Use the `data` prop for prefilled value
                          onChange={(event, editor) => {
                            const data = editor.getData();
                            // const plainText = stripHtml(data);
                            // Full editor content
                            setEditBlog((prevState) => ({
                              ...prevState,
                              body: data, // Keep the HTML content here
                            }));
                          }}
                          config={{
                            licenseKey: "GPL",
                            plugins: [
                              Essentials,
                              Paragraph,
                              Bold,
                              Italic,
                              Heading,
                              Link,
                              List,
                              BlockQuote,
                              MediaEmbed,
                              PasteFromOffice,
                              Font,
                              Alignment,
                            ],
                            toolbar: [
                              "heading",
                              "|",
                              "bold",
                              "italic",
                              "link",
                              "|",
                              "bulletedList",
                              "numberedList",
                              "|",
                              "blockQuote",
                              "|",
                              "undo",
                              "redo",
                              "|",
                              "alignment:left",
                              "alignment:center",
                              "alignment:right",
                              "alignment:justify",
                              "|",
                              "fontColor",
                              "fontBackgroundColor",
                              "fontSize",
                            ],
                            language: "en", // Set language to English
                            alignment: {
                              options: ["left", "center", "right", "justify"],
                            },
                            typing: {
                              direction: "ltr", // Force Left-to-Right
                            },
                          }}
                        />
                      </div>
                    </div>

                    <label className="font-raleway text-[16px] font-medium leading-[18.78px] text-left text-[#000000]">
                      Select Bond
                    </label>
                    <div className="flex mt-2 mb-4">
                      {/* <input
                        type="number"
                        value={editBlog?.bondId || ""}
                        placeholder="Enter bond ID"
                        className="w-full h-14 p-2.5 border border-[#E6E6E6] rounded-[13px]"
                        onChange={(e) =>
                          setEditBlog((prevState) => ({
                            ...prevState,
                            bondId: e.target.value,
                          }))
                        }
                      /> */}
                      <select
                        className="w-full h-14 p-2.5 border border-[#E6E6E6] rounded-[13px] "
                        name="section"
                        value={editBlog?.bondId || ""}
                        onChange={(e) =>
                          setEditBlog((prevState) => ({
                            ...prevState,
                            bondId: e.target.value,
                          }))
                        }
                      >
                        <option value="">Select section</option>
                        {cmsBondListData &&
                          cmsBondListData?.map((section) => (
                            <option key={section.value} value={section.id}>
                              {section.name}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>
                }
                onUpload={() => addNewBlog("edit")}
                ButtonValue="Update"
                onClose={closeModalEdit}
                isDisabled={isSubmitting}
              />
            )}
          </div>
        </div>
      </div>

      <div className="w-full font-poppins mt-3 rounded-[10px] border-t pt-4 bg-white">
        <ReactTable
          key={JSON?.stringify(announcementsData)}
          defaultData={announcementsData || []}
          columns={columns}
        />
      </div>

      {announcementsData?.length > 0 && (
        <div className="w-auto">
          <CustomPagination
            currentPage={page}
            setCurrentPage={setPage}
            totalItems={total}
            itemsPerPage={10}
            maxPageNumbersToShow={5}
            storageKey="announcementPage"
          />
        </div>
      )}

      {/* Add Delete Confirmation Modal */}
      <DeleteConfirmationModal
        isOpen={deleteConfirmation.isOpen}
        onClose={() => setDeleteConfirmation({ isOpen: false, id: null })}
        onConfirm={handleDelete}
        message="Are you sure you want to delete this announcement? This action cannot be undone."
      />
    </div>
  );
}

export default UserManagementMain;
